export { default } from '../modules/flags';